import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "..";

export interface CallLogsToastItem {
  id: string;
  title?: string;
  subtitle?: string;
  description?: string;
  meta?: any;
  createdAt: number;
}

const initialState: CallLogsToastItem[] = [];

export const callLogsToastsSlice = createSlice({
  name: "callLogsToasts",
  initialState,
  reducers: {
    addCallLogsToast: (state, action: PayloadAction<CallLogsToastItem>) => {
      // Insert new toast at the front, then dedupe by a stable key.
      const newState = [action.payload, ...state];

      const seen = new Set<string>();
      const uniqueState = newState.filter((item) => {
        // Build a stable dedupe key for the notification.
        const additionalData =
          item?.meta?.raw?.notification?.additionalData ||
          item?.meta?.raw?.additionalData;
        const notif = item?.meta?.raw?.notification || item?.meta?.raw;

        const reminderId = additionalData?.reminder_id;
        const notificationId = notif?.notificationId || notif?.id;
        const title = item.title || "";
        const description = item.description || "";

        const key = reminderId ?? notificationId ?? `${title}::${description}`;

        if (!key) return true; // can't dedupe without a key
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      });

      return uniqueState;
    },
    // removeReminderToast: (state, action: PayloadAction<string>) => {
    //   const payload = action.payload;
    //   // allow removing by the toast id OR by the notification's reminder_id (or other reminder identifiers)
    //   return state.filter((t) => {
    //     const notifRemId =
    //       t?.meta?.raw?.notification?.additionalData?.reminder_id;
    //     const metaRemId = t?.meta?.reminderId || t?.meta?.reminder?.id;
    //     return (
    //       t.id !== payload && notifRemId !== payload && metaRemId !== payload
    //     );
    //   });
    // },
    clearCallLogsToasts: () => {
      return [];
    },
  },
});

export const { addCallLogsToast, clearCallLogsToasts } =
  callLogsToastsSlice.actions;

export const selectCallLogsToasts = (state: RootState) =>
  state.callLogsToasts as CallLogsToastItem[];

export default callLogsToastsSlice.reducer;
